import { Badge } from '@/components/ui/badge';
import { MeetingStatus, MeetingStatusLabelMap } from '@airreading/common/data';
import clsx from 'clsx';

interface MeetingStatusBadgeProps {
  status: MeetingStatus | null;
}

const MeetingStatusColorMap: Record<MeetingStatus, string> = {
  [MeetingStatus.waiting]: 'bg-orange-600',
  [MeetingStatus.started]: 'bg-green-600',
  [MeetingStatus.ended]: 'bg-slate-600',
  [MeetingStatus.canceled]: 'bg-slate-600',
};

export function MeetingStatusBadge({ status }: MeetingStatusBadgeProps) {
  if (!status) {
    return null;
  }

  const colorClass = MeetingStatusColorMap[status];
  const label = MeetingStatusLabelMap[status];

  return <Badge className={clsx(colorClass)}>{label}</Badge>;
}
